const EIGHT_BIT_COLOR_MAX = 255;

function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
}

function rgbToHex(r, g, b) {
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export class ColorFormatConverter {
    constructor() {}

    static convertCesiumColorToHexColor(cesiumColor) {
        let r = Math.round(cesiumColor.red * EIGHT_BIT_COLOR_MAX);
        let g = Math.round(cesiumColor.green * EIGHT_BIT_COLOR_MAX);
        let b = Math.round(cesiumColor.blue * EIGHT_BIT_COLOR_MAX);
        return rgbToHex(r, g, b);
    }
}
